import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { GlobalFilter } from "../../../../components/Table/GlobalFilter";
import { COLUMNS } from "./FormsAndTemplatesColumnsV2";
import '../../CenterAdmin/ManageStaff/ManageStaff.scss';
import { deleteFormTemplate, getAllFormTemplatesByType } from "core/services/api";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import {
  getAllFormTemplateTypes,
} from "../../../../core/services/api";
import customSelectStyles from "components/CustomSelect/CustomSelectStyle";
import Toast from "../../../../components/Toast";
import { useSelector } from "react-redux";

/**
 * Lists all form templates by type.
 * 
 * @returns 
 */
export const FormsAndTemplatesV2 = () => {
  const columns = useMemo(() => COLUMNS, [])
  const [loading, toggleLoading] = useState<boolean>(false)
  const [formTemplateTypes, setFormTemplateTypes] = useState<any>()
  const [currentFormTemplateType, setCurrentFormTemplateType] = useState<any>('COMMON')
  const location = useLocation()
  const [displayToast, toggleDisplayToast] = useState<any>()
  const readOnlys = useSelector((state: any) => state?.user?.readOnly)
  // const dropdownFormTemplateTypes = formTemplateTypes?.map((val: any) => {
  //   return {
  //     label: val,
  //     value: val
  //   }
  // })
  const dropdownFormTemplateTypes = [
    { label: 'CANCER', value: 'CANCER' },
    { label: 'COMMON', value: 'COMMON' },
    { label: 'CONSENT', value: 'CONSENT' },
  ]
  const [data, setData] = useState([])
  const history = useHistory()
  const componentRef = useRef()

  /**
   * Get all template types on page load.
   */
  useEffect(() => {
    // toggleLoading(true);
    getAllFormTemplateTypes().then((res: any) => {
      toggleLoading(false);
      if (res && res.length > 1) {
        setFormTemplateTypes(res);
        //setCurrentFormTemplateType(res[0]);
      }
    }).catch((err: any) => {
      toggleLoading(false);
      console.log(err, "error")
    })
  }, [])

  /**
   * Reload table based upon selected form template type.
   */
  useEffect(() => {
    if (currentFormTemplateType) {
      // toggleLoading(true);
      getAllFormTemplatesByType(currentFormTemplateType)
        .then((res) => {
          toggleLoading(false);
          setData(res)
        })
        .catch((err) => {
          toggleLoading(false);
          console.log("err", err)
        })
    }
  }, [currentFormTemplateType])

  /**
   * Redirects to another react page based upon "origin".
   * 
   * @param path 
   * @param origin 
   */
  const redirectTo = (path: any, origin: any) => {
    console.log(origin)

    if (origin === "add") {
      // TODO
    }

    if (origin === "edit") {
      history.push({
        pathname: `/edit-forms-menu/${path}`,
        state: { consentType: currentFormTemplateType }
      })
    }
  }
  const handleDelete = (path: any) => {
    console.log("inside Delete", path)
    deleteFormTemplate(`${path}`)
      .then((res: any) => {
        toggleDisplayToast({ text: "Form Template Deleted Successfully", type: "success" });
      })
      .catch((err) => {
        toggleDisplayToast({ text: "Cannot Delete Form Template", type: "error" });
      })

  }

  useEffect(() => {
    setCurrentFormTemplateType(location?.state?.consentType)
    if (location?.state?.previousPath != 'editConsent') {
      localStorage.removeItem("globalFilterConsent")
      setCurrentFormTemplateType('COMMON')
    }
  }, [location])




  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state

  useEffect(() => {
    // Load the stored filter value from local storage
    const storedFilter = localStorage.getItem('globalFilterConsent');
    console.log(storedFilter, "stored Filter")
    if (storedFilter) {
      setGlobalFilter(storedFilter); // Apply the stored filter to the table
    }
  }, [setGlobalFilter, data]);

  return (
    <div className="services-wrapper-admin">
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "50%",
          }}
        >
          <div
            style={{ width: "3rem", height: "3rem" }}
            className="spinner-border text-primary"
          ></div>
        </div>)
      }
      <div className="manage-staff-patients-container">
        <div style={{ marginLeft: "-22px" }} className="manage-staff-patients-heading">
          <div
            className="approval-back-image"
            onClick={() => {
              history.push("/")
            }}
          >
            <img
              src={"../../../assets/images/back-icon.svg"}
              height={"60px"}
              width={"60px"}
              alt="back button"
              className="back_button"
            />
          </div>
          <div className="manage-staff-text">Forms & Templates</div>
        </div>
        <div className="row add-new">
          <div className="filter-services">
            <div>
              <label className="filter-label">Filter By Form Template Type</label>
              <div id="formTypesSelect" className="custom-react-select">
                <Select
                  styles={customSelectStyles()}
                  className=""
                  name="center"
                  value={{
                    label: currentFormTemplateType,
                    value: currentFormTemplateType
                  }}
                  options={dropdownFormTemplateTypes}
                  onChange={(evnt: any) => {
                    setCurrentFormTemplateType(evnt?.value);
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {currentFormTemplateType === 'CONSENT' ? <>  <button
                //id="add-button"
                //className="button-container"
                className={`add-new-forms-button ${readOnlys ? 'read-only' : ''}`}
                disabled={readOnlys}
                onClick={() => history.push("/add-form-template")}
              >
                Add New Consents
              </button></> : <></>}

            </div>
          </div>
          <div

            className="search-container">
            <div>
              <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            </div>
          </div>

          <table
            {...getTableProps()}
            // @ts-ignore
            ref={componentRef}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          paddingLeft: "40px",
                        }}
                      >
                        {column.render("Header")}
                        <span>
                          {column.isSorted
                            ? column.isSortedDesc
                              ? " 🔽"
                              : " 🔼"
                            : ""}
                        </span>
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody
              className="border-radiusImportant"
              {...getTableBodyProps()}
            >
              {rows.map((row) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                    {row.cells.map((cell: any) => {
                      return (
                        <td
                          onClick={() => {
                            if (cell?.column?.id?.toLowerCase() === "edit") {
                              redirectTo(cell?.row?.original?.id, "edit")
                            }
                            if (
                              cell?.column?.id?.toLowerCase() === "delete"
                            ) {
                              if (readOnlys) return null
                              // handleDelete(cell?.row?.original?.id)
                              console.log(cell?.row, "rowww")
                              toggleDisplayToast({
                                // @ts-ignore
                                text: `Are you sure you want to delete this form?`,
                                type: "warning",
                                onClickText: "Yes",
                                // @ts-ignore
                                patient: cell?.row?.original?.id,
                              })
                            }
                          }}
                          style={{
                            maxWidth: "400px",
                            width: "300px",
                            wordWrap: "break-word",
                            maxHeight: "100px",
                            paddingLeft: "40px",
                            verticalAlign: "left",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "18px",
                            lineHeight: "24px",
                            letterSpacing: "1.35px",
                            textAlign: "initial",
                            textTransform: "capitalize",
                          }}
                          {...cell.getCellProps()}
                        >
                          {cell.render("Cell")}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
            <tfoot>
              {footerGroups.map((footerGroup) => (
                <tr {...footerGroup.getFooterGroupProps()}>
                  {footerGroup.headers.map((column) => (
                    <td {...column.getFooterProps()}>
                      {column.render("Footer")}
                    </td>
                  ))}
                </tr>
              ))}
            </tfoot>
          </table>
        </div>
      </div>
      {
        displayToast && (
          <Toast
            // @ts-ignore
            textMessage={displayToast?.text}
            // @ts-ignore
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={
              // @ts-ignore
              displayToast?.onClickText ? displayToast?.onClickText : null
            }
            onClick={() =>
              // @ts-ignore
              displayToast?.patient
                ? // @ts-ignore
                handleDelete(displayToast?.patient)
                : null
            }
            // @ts-ignore
            type={displayToast?.type}
          />
        )
      }
    </div>
  )
}
